export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/freelance_impact_perseus/freelance-economy-2018.16866d8.pdf";